import { UnderwritingReport } from "src/routes/cma/endpoints/reports";
import { ActivityState } from "src/routes/cma/endpoints/reports/ActivityState";
import { configSyncedValuationStages, postUwValuationStages } from "src/routes/cma/endpoints/reports/ValuationStage";
import { Maybe } from "./types";

export function reportIsReadOnly(report: Maybe<UnderwritingReport>): boolean {
  if (report === undefined || report === null) {
    return false;
  }

  if (report.activity_state !== ActivityState.active || report.status === "Finalized") {
    return true;
  }

  return false;
}

export function readyPlanStepIsReadOnly(report: Maybe<UnderwritingReport>): boolean {
  if (report === undefined || report === null) {
    return false;
  }

  if (reportIsReadOnly(report)) {
    return true;
  }

  if (report.valuation_stage && postUwValuationStages.includes(report.valuation_stage)) {
    return true;
  }

  return false;
}

/**
 * Whether this report's ready plan configuration is validated against Blueprint before finalize.
 *
 * Only a configuration Blueprint consumes can be rejected when it syncs onto a project, so for the later
 * stages this check could only ever be a false block — and the Ready Plan step is read-only post-UW, leaving
 * the analyst no way to clear one. property-api applies the same rule on finalize
 */
export function readyPlanConfigIsValidatedOnFinalize(report: Maybe<UnderwritingReport>): boolean {
  return !!report?.valuation_stage && configSyncedValuationStages.includes(report.valuation_stage);
}
